import React, { useEffect, useState, useRef } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import GlobalCustomTable from "../../../GlobalCustomTable";
import _debounce from "lodash/debounce";
import {
    Breadcrumb_inputName,
    BreadcrumbShowCountlabel,
    commonPageField,
    commonPageFieldSuccess,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    formValid,
    initialFiledFunc,
    resetFunction
} from "../../../components/Common/validationFunction";
import { SaveButton } from "../../../components/Common/CommonButton";
import {
    CommonConsole,
    loginSelectedPartyID,
    loginUserID,
    metaTagLabel
} from "../../../components/Common/CommonFunction";
import { mode, url, pageId } from "../../../routes/index";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { saveMsgUseEffect, userAccessUseEffect } from "../../../components/Common/CommonUseEffect";
import { globalTableSearchProps } from "../../../components/Common/SearchBox/MySearch";
import { C_Select } from "../../../CustomValidateForm";
import {
    editCashBookHeadIDSuccess,
    getCashBookHeadList,
    saveCashBookHead,
    saveCashBookHeadSuccess,
    updateCashBookHeadID,
    updateCashBookHeadIDSuccess
} from "../../../store/Administrator/CashBookHeadRedux/action";
import { deltBtnCss } from "../../../components/Common/ListActionsButtons";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { CashBookHead_List_API, PaymentModeDropdownAPIGET } from "../../../helpers/backend_helper";


// ------------------------------------------------------------------
// Constants
// ------------------------------------------------------------------
const EXP_INC_OPTIONS = [
    { value: "Expense", label: "Expense" },
    { value: "Income", label: "Income" },
];
// Saved sign ("-" / "+") or text -> dropdown value
function signToExpInc(v) {
    if (v === "Minus" || v === "-" || v === "Expense") return "Expense";
    if (v === "Plus" || v === "+" || v === "Income") return "Income";
    return "";
}

const CONFIRM_ALERT_TYPE = 8;   // customAlert type for "Are you sure?"
const TOGGLE_FIELDS = ["Prepopulated", "ConfirmationRequired", "Editable", "Active"];


const CashBookHead = (props) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const fileds = {
        id: "",
        GroupName: "",
        HeadName: "",
        ExpInc: "",
        Prepopulated: false,
        ConfirmationRequired: false,
        Editable: true,
        Active: true,
        PartyWiseHead: "",
        ParentHeadMaster: "",
        Action: "",
        Party: "",
    };

    // ------------------------------------------------------------------
    // State
    // ------------------------------------------------------------------
    const [state, setState] = useState(() => initialFiledFunc(fileds));
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [modalCss, setModalCss] = useState(false);
    const [userPageAccessState, setUserAccState] = useState('');
    const [editCreatedBy, seteditCreatedBy] = useState("");
    const [searchText, setSearchText] = useState("");

    const [selectedHead, setSelectedHead] = useState(null);     // Head Name dropdown
    const [selectedMode, setSelectedMode] = useState(null);     // Payment Mode dropdown
    const [modeOptions, setModeOptions] = useState([]);         // Payment Mode options
    const [modeLoading, setModeLoading] = useState(false);

    // Grid rows. One row = one Head + one Payment Mode.
    const [details, setDetails] = useState([]);
    const [editHeadId, setEditHeadId] = useState("");           // head id when opened for edit
    const rowCounter = useRef(0);
    const [headList, setHeadList] = useState([]);

    const {
        postMsg,
        updateMsg,
        pageField,
        saveBtnloading,
        userAccess,
        commonPartyDropSelect,
    } = useSelector((state) => ({
        saveBtnloading: state.CashBookHeadReducer.saveBtnloading,
        postMsg: state.CashBookHeadReducer.postMsg,
        updateMsg: state.CashBookHeadReducer.updateMessage,   // reducer key is updateMessage
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,

        commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
    }));

    const { values, isError, fieldLabel } = state;

    const location = { ...history.location };
    const hasShowloction = location.hasOwnProperty(mode.editValue);
    const hasShowModal = props.hasOwnProperty(mode.editValue);


    // ------------------------------------------------------------------
    // useEffects
    // ------------------------------------------------------------------

    useEffect(() => {   // page field (labels)
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.CASH_BOOK_HEAD));
    }, []);

    useEffect(() => {   // head list for the Head Name dropdown
        fetchHeadList();
    }, []);

    useEffect(() => {   // payment modes, reloads when the selected party changes
        const partyId = Number(commonPartyDropSelect?.value) || Number(loginSelectedPartyID());
        if (!partyId) {
            setModeOptions([]);
            return;
        }
        fetchPaymentModes(partyId);
    }, [commonPartyDropSelect]);

    useEffect(() => userAccessUseEffect({   // userAccess useEffect
        props,
        userAccess,
        dispatch,
        setUserAccState,
    }), [userAccess]);

    useEffect(() => {   // edit mode: bind the head sent from the list page
        if (!(hasShowloction || hasShowModal)) return;

        let hasEditVal = null;
        if (hasShowloction) {
            setPageMode(location.pageMode);
            hasEditVal = location.editValue;
        } else if (hasShowModal) {
            hasEditVal = props.editValue;
            setPageMode(props.pageMode);
            setModalCss(true);
        }

        if (hasEditVal) {
            const head = Array.isArray(hasEditVal) ? hasEditVal[0] : hasEditVal;

            if (head) {
                const { id, HeadName, HeadId, PaymentModeID, SubHead = [] } = head;
                const parentHeadId = HeadId ?? id;              // master head id

                setState(i => {
                    const state = { ...i };
                    state.values.id = parentHeadId;
                    state.values.HeadName = HeadName || "";
                    Object.keys(fileds).forEach((k) => {
                        if (state.hasValid[k]) state.hasValid[k].valid = true;
                    });
                    return state;
                });

                setSelectedHead({ value: parentHeadId, label: HeadName });
                setEditHeadId(id);                              // record id used for update
                seteditCreatedBy(head.Createdby ?? head.CreatedBy);
                dispatch(Breadcrumb_inputName(HeadName));

                // SubHead rows -> grid rows
                setDetails(SubHead.map((saved) => ({
                    rowKey: `row_${++rowCounter.current}`,
                    id: saved.id,
                    headId: parentHeadId,
                    parentHeadName: HeadName,
                    modeId: saved.PaymentModeID ?? PaymentModeID ?? null,
                    modeName: saved.PaymentModeName ?? "",
                    partyId: saved.PartyID ?? saved.Party ?? Number(loginSelectedPartyID()),
                    HeadName: saved.HeadName || "",
                    ExpInc: signToExpInc(saved.ExpInc),
                    Prepopulated: !!saved.Prepopulated,
                    ConfirmationRequired: !!saved.ConfirmationRequired,
                    Editable: !!saved.IsEditable,
                    Active: !!saved.IsActive,
                })));
            }
        }
        dispatch(editCashBookHeadIDSuccess({ Status: false }));
    }, []);

    useEffect(() => saveMsgUseEffect({   // after save -> go to list
        postMsg, pageMode,
        history, dispatch,
        postSuccss: saveCashBookHeadSuccess,
        resetFunc: { fileds, state, setState },
        listPath: url.CashBookHeadList
    }), [postMsg]);

    useEffect(() => {   // after update -> go to list
        if (updateMsg.Status === true && updateMsg.StatusCode === 200 && !modalCss) {
            setState(() => resetFunction(fileds, state));
            history.push({ pathname: url.CashBookHeadList });
        } else if (updateMsg.Status === true && !modalCss) {
            dispatch(updateCashBookHeadIDSuccess({ Status: false }));
            customAlert({
                Type: 3,
                Message: JSON.stringify(updateMsg.Message),
            });
        }
    }, [updateMsg, modalCss]);

    useEffect(() => {   // page field -> form labels
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster;
            comAddPageFieldFunc({ state, setState, fieldArr });
        }
    }, [pageField]);

    const debounceHandleSearch = _debounce((val) => setSearchText(val), 300);

    useEffect(() => {   // top bar search box
        globalTableSearchProps({ onSearch: debounceHandleSearch });
    });

    // grid rows after search
    const q = (searchText || "").trim().toLowerCase();
    const visibleDetails = !q ? details : details.filter((r) =>
        [r.parentHeadName, r.HeadName, r.ExpInc, r.modeName]
            .some((v) => (v ?? "").toString().toLowerCase().includes(q))
    );

    useEffect(() => {   // row count in page header
        if (userPageAccessState === '' || modalCss) return;
        dispatch(BreadcrumbShowCountlabel(`Count:${visibleDetails.length}`));
    }, [visibleDetails.length, userPageAccessState, modalCss]);

    useEffect(() => {
        if (modeOptions.length === 0) return;

        setDetails((prev) => {
            let changed = false;

            const updated = prev.map((row) => {
                if (!row.modeId) return row;

                const selected = modeOptions.find(
                    (option) =>
                        String(option.value) === String(row.modeId)
                );

                if (!selected || row.modeName === selected.label) {
                    return row;
                }

                changed = true;
                return { ...row, modeName: selected.label };
            });

            return changed ? updated : prev;
        });

        // Bind the first saved Payment Mode to the top dropdown in edit mode
        if (pageMode === mode.edit && !selectedMode) {
            const firstRow = details.find((row) => row.modeId);

            if (firstRow) {
                const selected = modeOptions.find(
                    (option) =>
                        String(option.value) === String(firstRow.modeId)
                );

                if (selected) {
                    setSelectedMode(selected);
                }
            }
        }
    }, [modeOptions, pageMode, details, selectedMode]);


    // ------------------------------------------------------------------
    // Dropdown options
    // ------------------------------------------------------------------
    const headNameOptions = (headList || []).map((h) => ({
        value: h.id,
        label: h.HeadName,
        ExpInc: h.ExpInc,
        is_mode_required: !!h.is_mode_required,
    }));

    // looks the flag up in the head list, so it also works in edit mode
    const isModeRequired = (headId) =>
        !!(headList || []).find((h) => String(h.id) === String(headId))?.is_mode_required;

    const modeRequired = isModeRequired(selectedHead?.value);


    // ------------------------------------------------------------------
    // Functions
    // ------------------------------------------------------------------

    async function fetchPaymentModes(partyId) {
        setModeLoading(true);
        try {
            const resp = await PaymentModeDropdownAPIGET(partyId);
            const rows = Array.isArray(resp) ? resp : (resp?.Data || []);

            setModeOptions(rows.map((item) => ({
                value: item.id ?? item.PaymentModeID,
                label: item.Payment_Mode ?? item.PaymentMode ?? item.Name ?? item.label,
            })));

            if (rows.length === 0 && resp?.Message) {
                customAlert({ Type: 4, Message: resp.Message });
            }
        } catch (error) {
            setModeOptions([]);
            customAlert({ Type: 4, Message: "Unable to load Payment Modes" });
        }
        setModeLoading(false);
    }

    async function fetchHeadList() {
        try {
            const resp = await CashBookHead_List_API();
            setHeadList(Array.isArray(resp?.Data) ? resp.Data : []);
        } catch (error) {
            setHeadList([]);
        }
    }

    function headOnchange(e) {   // Head Name dropdown changed (grid rows are kept)
        if (!e || !e.is_mode_required) setSelectedMode(null);
        setSelectedHead(e || null);
        dispatch(Breadcrumb_inputName(e ? e.label : ""));

        setState((i) => {
            const a = { ...i };
            a.values.id = e ? e.value : "";
            a.values.HeadName = e ? e.label : "";
            a.hasValid.HeadName.valid = true;
            a.isError.HeadName = "";
            return a;
        });
    }

    function modeOnchange(e) {   // Payment Mode dropdown changed
        setSelectedMode(e || null);

        // edit mode has no Add button, so push the mode into the existing rows
        if (pageMode === mode.edit && e) {
            setDetails((prev) => prev.map((row) =>
                row.modeId
                    ? row   // keep a mode that was already saved
                    : { ...row, modeId: e.value, modeName: e.label }
            ));
        }
    }

    function addButtonHandler() {   // Add button -> new row for selected Head + Mode
        if (!selectedHead) {
            customAlert({ Type: 3, Message: "Please select Head Name before adding" });
            return;
        }

        if (modeRequired && !selectedMode) {
            customAlert({ Type: 3, Message: "Please select Payment Mode before adding" });
            return;
        }

        const partyId = Number(loginSelectedPartyID());
        if (!partyId) {
            customAlert({ Type: 3, Message: "Please select a Party from the top party selector" });
            return;
        }

        const newRow = {
            rowKey: `row_${++rowCounter.current}`,
            id: undefined,
            headId: selectedHead.value,
            parentHeadName: selectedHead.label,
            modeId: modeRequired && selectedMode ? selectedMode.value : null,
            modeName: modeRequired && selectedMode ? selectedMode.label : "",
            partyId: partyId,
            HeadName: "",
            ExpInc: selectedHead.ExpInc,
            Prepopulated: false,
            ConfirmationRequired: false,
            Editable: true,
            Active: true,
        };

        setDetails(details.concat(newRow));
    }

    async function deleteRowHandler(row) {   // Delete button -> confirm -> remove ONLY this row
        const isPermission = await customAlert({
            Type: CONFIRM_ALERT_TYPE,
            Message: `${alertMessages.deleteOrNot} Party Wise Head : "${row.HeadName || row.parentHeadName}"`,
        });
        if (isPermission) {
            setDetails((prev) => prev.filter((r) => r.rowKey !== row.rowKey));
        }
    }

    // ------------------------------------------------------------------
    // Grid columns
    // ------------------------------------------------------------------
    const gridColumns = [

        {//------------- Parent Head column ----------------------------------
            dataField: "parentHeadName",
            text: fieldLabel.ParentHeadMaster,
            headerStyle: () => ({ width: "14%" }),
            formatter: (value, row) => <span>{row.parentHeadName || "-"}</span>,
        },

        {//------------- Head Name column ----------------------------------
            dataField: "HeadName",
            text: fieldLabel.HeadName,
            headerStyle: () => ({ width: "18%" }),
            formatter: (value, row) => (
                <Input
                    key={`HeadName-${row.rowKey}`}
                    type="text"
                    defaultValue={row.HeadName}
                    placeholder="Party-specific Head Name"
                    autoComplete="off"
                    onChange={(e) => { row["HeadName"] = e.target.value; }}
                />
            ),
        },

        {
            dataField: "ExpInc",
            text: fieldLabel.ExpInc,
            isDummyField: true,
            headerStyle: () => ({ width: "17%" }),
            formatter: (value, row) => <span>{row.ExpInc || "-"}</span>,
        },

        {//------------- Payment Mode column (name only) ----------------------------------
            dataField: "modeName",
            text: fieldLabel.Mode || "Mode",
            isDummyField: true,
            headerStyle: () => ({ width: "14%" }),
            formatter: (value, row) => <span>{row.modeName || "-"}</span>,
        },

        // ------------- Switch columns ----------------------------------
        // ...TOGGLE_FIELDS.map((field) => ({
        //     dataField: field,
        //     text: fieldLabel[field],
        //     headerStyle: () => ({ width: "8%", textAlign: "center" }),
        //     style: { textAlign: "center", verticalAlign: "middle" },
        //     formatter: (value, row) => (
        //         <div className="form-check form-switch d-flex justify-content-center m-0 p-0">
        //             <Input
        //                 key={`${field}-${row.rowKey}`}
        //                 type="checkbox"
        //                 className="form-check-input m-0"
        //                 style={{ width: "2.5rem", height: "1.3rem", cursor: "pointer", float: "none" }}
        //                 defaultChecked={!!row[field]}
        //                 onChange={(e) => { row[field] = e.target.checked; }}
        //             />
        //         </div>
        //     ),
        // })),

        {//------------- Action column ----------------------------------
            dataField: "action",              // was "rowKey", must not match keyField
            text: fieldLabel.Action || "Action",
            isDummyField: true,
            headerStyle: () => ({ width: "6%", textAlign: "center" }),
            style: { textAlign: "center", verticalAlign: "middle" },
            formatter: (value, row) => (
                <Button
                    type="button"
                    id={`btn-delete-${row.rowKey}`}
                    className={deltBtnCss}
                    title="Delete Party Wise Head"
                    onClick={() => deleteRowHandler(row)}
                >
                    <i className="mdi mdi-delete font-size-16"></i>
                </Button>
            ),
        },
    ];


    // ------------------------------------------------------------------
    // Save
    // ------------------------------------------------------------------
    const SaveHandler = async (event) => {
        event.preventDefault();

        try {
            // top Head dropdown is not required, every row carries its own head
            if (state.hasValid.HeadName) state.hasValid.HeadName.valid = true;
            TOGGLE_FIELDS.forEach((k) => {
                if (state.hasValid[k]) state.hasValid[k].valid = true;
            });

            if (!formValid(state, setState)) return;

            if (details.length === 0) {
                customAlert({ Type: 3, Message: "Please select a Head, then click Add" });
                return;
            }

            // every row needs Head Name and Exp/Inc
            const validationMessages = [];
            details.forEach((row, index) => {
                if (!(row.HeadName || "").trim()) {
                    validationMessages.push({ [`Row ${index + 1} (${row.parentHeadName})`]: "Head Name is required" });
                }
                if (!row.ExpInc) {
                    validationMessages.push({ [`Row ${index + 1} (${row.parentHeadName})`]: "Exp/Inc is required" });
                }
                if (isModeRequired(row.headId) && !row.modeId) {
                    validationMessages.push({ [`Row ${index + 1} (${row.parentHeadName})`]: "Payment Mode is required" });
                }
            });

            if (validationMessages.length > 0) {
                customAlert({ Type: 4, Message: validationMessages });
                return;
            }

            // body = array, one object per grid row
            const jsonBody = JSON.stringify(
                details.map((row) => ({
                    ...(row.id ? { id: row.id } : {}),
                    HeadID: row.headId,
                    PaymentModeID: isModeRequired(row.headId) ? row.modeId : null,
                    PartyID: row.partyId,
                    HeadName: row.HeadName.trim(),
                    ExpInc: row.ExpInc,
                    Prepopulated: row.Prepopulated,
                    ConfirmationRequired: row.ConfirmationRequired,
                    IsEditable: row.Editable,
                    IsActive: row.Active,
                }))
            );

            if (pageMode === mode.edit) {
                dispatch(updateCashBookHeadID({ jsonBody, updateId: editHeadId || values.id }));
            } else {
                dispatch(saveCashBookHead({ jsonBody }));
            }
        } catch (e) { CommonConsole(e); }
    };


    // ------------------------------------------------------------------
    // Render
    // ------------------------------------------------------------------
    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>

                        <Card className="text-black">
                            <CardHeader className="card-header text-black c_card_header">
                                <h4 className="card-title text-black">{userPageAccessState.PageDescription}</h4>
                                <p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                            </CardHeader>

                            <CardBody className="vh-10 0 text-black">
                                <form noValidate>
                                    <Card>
                                        <CardBody className="c_card_body">

                                            {/* Head + Payment Mode + Add */}
                                            <Row className="mb-3 align-items-end">

                                                <Col md={4}>
                                                    <FormGroup className="mb-0">
                                                        <Label>{fieldLabel.HeadName}</Label>
                                                        <C_Select
                                                            name="HeadName"
                                                            value={selectedHead}
                                                            options={headNameOptions}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            placeholder="Select Head Name..."
                                                            onChange={headOnchange}
                                                            styles={{
                                                                menu: provided => ({ ...provided, zIndex: 2 })
                                                            }}
                                                        />
                                                        {isError.HeadName?.length > 0 && (
                                                            <span className="text-danger f-8"><small>{isError.HeadName}</small></span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                {modeRequired && (
                                                    <Col md={4}>
                                                        <FormGroup className="mb-0">
                                                            <Label>{fieldLabel.Mode || "Mode"}</Label>
                                                            <C_Select
                                                                name="Mode"
                                                                value={selectedMode}
                                                                options={modeOptions}
                                                                isLoading={modeLoading}
                                                                isSearchable={true}
                                                                isClearable={true}
                                                                placeholder="Select Payment Mode..."
                                                                onChange={modeOnchange}
                                                                styles={{
                                                                    menu: provided => ({ ...provided, zIndex: 2 })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                )}
                                                {pageMode !== mode.edit && (
                                                    <Col md={2}>
                                                        <Button
                                                            type="button"
                                                            color="primary"
                                                            title="Add Party Wise Head"
                                                            onClick={addButtonHandler}
                                                        >
                                                            <i className="mdi mdi-plus font-size-16 me-1" />
                                                            Add
                                                        </Button>
                                                    </Col>
                                                )}
                                            </Row>

                                            {/* Grid */}
                                            <Row>
                                                <Col sm={12}>
                                                    <div style={{ maxHeight: "700px", overflow: "auto" }}>
                                                        <GlobalCustomTable
                                                            keyField="rowKey"
                                                            data={visibleDetails}
                                                            columns={gridColumns}
                                                            classes="custom-table"
                                                            bordered
                                                            condensed
                                                            isPaginationTotalStandalone={false}
                                                            noDataIndication={
                                                                <div className="text-danger text-center">
                                                                    Select a Head, then click Add.
                                                                </div>
                                                            }
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            {/* Save */}
                                            <FormGroup className="mt-3">
                                                <Row>
                                                    <Col sm={2}>
                                                        <SaveButton
                                                            loading={saveBtnloading}
                                                            pageMode={pageMode}
                                                            onClick={SaveHandler}
                                                            userAcc={userPageAccessState}
                                                            editCreatedBy={editCreatedBy}
                                                            module={"CashBookHead"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>

                                        </CardBody>
                                    </Card>
                                </form>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment>
        );
    } else {
        return <React.Fragment></React.Fragment>;
    }
};

export default CashBookHead;